var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.ready
    ? _c("div", {}, [
        _vm.loading
          ? _c(
              "span",
              { staticClass: "loading" },
              [
                _c("ClipLoader", {
                  attrs: { color: "#2e3f50", loading: _vm.loading, size: 20 },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.lessonExercises && _vm.lessonExercises.length
          ? _c(
              "div",
              { staticClass: "StudentGroups__Container" },
              _vm._l(_vm.lessonExercises, function (exercise) {
                return _c(
                  "div",
                  {
                    key: exercise.id,
                    staticClass: "StudentGroupsWidget__Component",
                    class: [exercise.isSelected && "green"],
                  },
                  [_c("p", [_vm._v(_vm._s(exercise.name))])]
                )
              }),
              0
            )
          : _vm._e(),
        _vm.lessonExercises && _vm.lessonExercises.length
          ? _c("div", { staticClass: "link-btn" }, [
              _c("a", { on: { click: _vm.showAll } }, [_vm._v("הצג הכל")]),
            ])
          : _vm._e(),
        !_vm.loading && !_vm.lessonExercises.length
          ? _c("div", [_vm._v("אין מקבצי פסיקה משויכים ליחידת הלימוד")])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }